import React, { useState } from "react";
import { Button, TextField, Typography } from "@material-ui/core";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import { useTranslation } from "react-i18next";
import checkoutServices from "~/services/checkoutServices";
import userUpdateService from "~/services/userUpdateService";

export default function DialogUserName({
  onClose,
  titleKey = "How can we call you",
  messageKey = "This name will be used in your appointments and in the notices sent to you",
}) {
  const { t } = useTranslation();

  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const regex = /[0-9]/;
  const hasNumbers = regex.test(name);
  const trimmedName = name.trim();
  const isValidName = trimmedName.length >= 2 && !hasNumbers;

  const submitForm = async () => {
    if (loading || !isValidName) return;

    setLoading(true);
    setErrorMessage("");
    try {
      await userUpdateService.pachUserUpdate(localStorage.getItem("@prit-web/userId"), {
        name: trimmedName,
      });

      const res = await checkoutServices.me();
      if (res?.data?.id) {
        localStorage.setItem("@prit-web/meData", JSON.stringify(res.data));
        localStorage.setItem("@prit-web/userId", res.data.id);
        localStorage.setItem("@prit-web/userName", JSON.stringify(trimmedName));
      }
      if (typeof onClose === "function") onClose();
    } catch (error) {
      console.error(error);
      const errorMsg = error?.response?.data?.message || error?.message || t("There was an error saving your name");
      setErrorMessage(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: "0 4px 8px 4px", maxWidth: 480, margin: "0 auto" }}>
      <Typography style={{ fontWeight: 700, fontSize: 22, textAlign: "left", marginBottom: 10, color: "#222", lineHeight: 1.3 }}>
        {t(titleKey)}
      </Typography>
      <Typography style={{ fontSize: 14, textAlign: "left", color: "#555", marginBottom: 24, lineHeight: 1.5 }}>
        {t(messageKey)}
      </Typography>

      <TextField
        value={name}
        onChange={(e) => {
          setName(e.target.value);
          if (errorMessage) setErrorMessage("");
        }}
        label={t("NAME")}
        variant="outlined"
        fullWidth
        error={hasNumbers}
        inputProps={{ maxLength: 100 }}
        style={{ marginBottom: hasNumbers ? 8 : 24 }}
        onKeyPress={(e) => {
          if (e.key === "Enter" && isValidName && !loading) submitForm();
        }}
      />

      {hasNumbers && (
        <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 24 }}>
          <ErrorOutlineIcon style={{ fontSize: 16, color: "#d32f2f" }} />
          <Typography style={{ fontSize: 13, color: "#d32f2f" }}>
            {t("Use only letters to continue")}
          </Typography>
        </div>
      )}

      {!hasNumbers && trimmedName.length > 0 && trimmedName.length < 2 && (
        <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 24 }}>
          <ErrorOutlineIcon style={{ fontSize: 16, color: "#d32f2f" }} />
          <Typography style={{ fontSize: 13, color: "#d32f2f" }}>
            {t("Name must have at least 2 characters")}
          </Typography>
        </div>
      )}

      {errorMessage && (
        <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 24 }}>
          <ErrorOutlineIcon style={{ fontSize: 16, color: "#d32f2f" }} />
          <Typography style={{ fontSize: 13, color: "#d32f2f" }}>
            {errorMessage}
          </Typography>
        </div>
      )}

      <Button
        onClick={submitForm}
        disabled={!isValidName || loading}
        style={{
          width: "100%",
          backgroundColor: !isValidName ? "#dddddd" : "#3f51b5",
          color: !isValidName ? "#999" : "#fff",
          textTransform: "none",
          fontWeight: 600,
          padding: "14px",
          borderRadius: "30px",
          fontSize: "16px",
          boxShadow: "none",
        }}
      >
        {loading ? t("Saving...") : t("continue")}
      </Button>
    </div>
  );
}
